import React from 'react';
import './LaboTools.css';

const TOOLS = [
  {
    id: 'prospection-b2b',
    icon: '🏢',
    title: 'Prospection B2B',
    description: 'Recherche de prospects via les données SIRENE (data.gouv.fr)',
  },
  {
    id: 'reception-client',
    icon: '📥',
    title: 'Réception Client',
    description: 'Accueil et prise en charge des véhicules clients',
  },
  {
    id: 'ai-search',
    icon: '✨',
    title: 'Assistant IA',
    description: 'Interrogez les données CRM en langage naturel',
  },
  {
    id: 'reporting-apv',
    icon: '📊',
    title: 'Reporting APV',
    description: 'KPIs et tendances du CA atelier : MO, Pièces, Trav. Ext.',
  },
  {
    id: 'nextlane-or',
    icon: '🔧',
    title: 'OR Atelier (Nextlane)',
    description: 'Ordres de réparation multi-concessions via API Datacar : clients, véhicules, factures, devis, lignes détaillées',
  },
  {
    id: 'nextlane-reporting',
    icon: '📊',
    title: 'Reporting Atelier (Nextlane)',
    description: 'CA atelier, marge pièces, taux de marge par département et concession — données Datacar',
  },
  {
    id: 'voice-agent',
    icon: '🎙️',
    title: 'Agent vocal IA',
    description: 'Configuration et historique des appels gérés par l\'agent vocal ElevenLabs × Ringover',
  },
  {
    id: 'prospection-pr',
    icon: '🔧',
    title: 'Prospection PR',
    description: 'Prospection pièces de rechange — déplacée ici le 2026-09-04, sa rubrique du menu latéral ne portait qu\'elle',
  },
  {
    id: 'liasses-fiscales',
    icon: '🧾',
    title: 'Liasses fiscales',
    description: 'Extraction IA de données depuis des lots de PDF (liasses, rapports…) → tableau structuré éditable + export Excel + chat d\'analyse',
  },
];

function LaboTools({ setView }) {
  return (
    <div className="page-container">
      <div className="labo-tools-grid">
        {TOOLS.map(tool => (
          <button
            key={tool.id}
            className="labo-tools-card"
            onClick={() => setView(tool.id)}
          >
            <div className="labo-tools-card-icon">{tool.icon}</div>
            <div className="labo-tools-card-info">
              <h3>{tool.title}</h3>
              <p>{tool.description}</p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}

export default LaboTools;
